import { components } from 'types/rest-schema';

export type OrganisationLovResponse = components['schemas']['OrganisationLovResponseModel'];

export enum NamedItemType {
    RiskCategory = 0,
    RiskControlStrategy = 1,
    ControlType = 2,
    ResponsibleFunction = 3,
    RiskLibraryCategory = 4,
    DetectionType = 5,
    RiskObservationClassification = 6,
    ReviewLogDecision = 7,
    SmType = 11,
    ControlsReviewLogDecision = 12,
    SMReviewLogDecision = 15,
}
